import React, { useState, useEffect } from "react";
import Header from "../../../../Global/Header/Header";
import Footer from "../../../../Global/Footer/Footer";
import { get, createUrl } from "../../../../network/AxiosInterceptor";
import { useNavigate } from "react-router-dom";

const AllReviews = (props) => {

    const navigate = useNavigate();

    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        get(createUrl('/api/reviews/getReviews')).then((response) => {
            setReviews(response.data)
        })
    }, []);

    const handleEditReview = (reviewId) => {
        const currUrl = window.location.pathname.split('/').slice(0,-1).join('/');
        navigate(`${currUrl}/review/${reviewId}`) 
    }

    return (
        <div>
            <Header />
            <div className="w-[100vw] overflow-x-scroll lg:overflow-x-hidden px-[9.5vw] lg:px-0 ">
                <div className="flex flex-col min-w-[600px] w-[80vw] lg:w-[max-content] m-auto mt-[10vw] lg:mt-[5vw] border-[1px] border-[rgba(0,0,0,0.2)] rounded-[10px] mb-[10vw] lg:mb-[5vw]">
                    <div className="flex flex-row justify-between p-[2vw] lg:p-[1vw] border-b-[1px] border-[rgba(0,0,0,0.2)]">
                        <p className="text-[2vw] lg:text-[1vw] font-bold min-w-[150px] w-[20vw] p-[1vw]">Reviewer Name</p>
                        <p className="text-[2vw] lg:text-[1vw] font-bold min-w-[150px] w-[20vw] p-[1vw]">Review Trip</p>
                        <p className="text-[2vw] lg:text-[1vw] font-bold min-w-[150px] w-[20vw] p-[1vw]">Review Month</p>
                        <p className="text-[2vw] lg:text-[1vw] font-bold min-w-[150px] w-[20vw] p-[1vw]">Review Status</p>
                    </div>
                    {reviews.length>0 && reviews.map((review, index) => {
                        return (
                            <div style={{ borderBottomWidth: `${index + 1 == reviews.length ? "0px" : ""}` , backgroundColor: `${review?.reviewStatus=='pause'?"rgba(155,155,155,0.3)":""}` }} className="flex flex-row justify-between p-[2vw] lg:p-[1vw] border-b-[1px] border-[rgba(0,0,0,0.2)]">
                                <p className="text-[2vw] lg:text-[1vw] min-w-[150px] w-[20vw] p-[1vw] flex flex-row">
                                    <PencilIcon className="w-[30px] h-[30px] lg:h-[2vw] lg:w-[2vw] mr-2 stroke-blue-500 hover:bg-gray-200 p-2 mt-[-5px] lg:mt-[-0.3vw] hover:rounded cursor-pointer" onClick={() => { handleEditReview(review.id) }} />
                                    {review.reviewExplorer}</p>
                                <p className="text-[2vw] lg:text-[1vw] min-w-[150px] w-[20vw] break-all p-[1vw]">{review.reviewTrip}</p>
                                <p className="text-[2vw] lg:text-[1vw] min-w-[150px] w-[20vw] p-[1vw]">{review.reviewTripMonth}</p>
                                <p className="text-[2vw] lg:text-[1vw] min-w-[150px] w-[20vw] p-[1vw]">{review?.reviewStatus}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
            <Footer />
        </div>
    )
};

const PencilIcon = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
            <path d="m15 5 4 4" />
        </svg>
    );
};

export default AllReviews;